module.exports = __webpack_public_path__ + "static/media/cover.db173c14.png";